import { FieldValues, useController } from "react-hook-form";

import {
    SelectInput,
    SelectInputBaseProps,
    SelectValueType,
} from "../fields/selectInput";

import { BaseRHFWidgetProps } from "./types";

interface RHFSelectInputProps<TFieldsValues extends FieldValues>
    extends
        BaseRHFWidgetProps<TFieldsValues, SelectValueType>,
        SelectInputBaseProps<SelectValueType> {
    onBlur?: () => void;
}

export function RHFSelectInput<TFieldsValues extends FieldValues>({
    name,
    control,
    options,
    label,
    filterOption,
    placeholder,
    className,
    nodeAfter,
    helpText,
    getPopupContainer,
    dropdownMatchSelectWidth,
    disabled,
    autoFocus,
    showSearch,
    onBlur,
}: RHFSelectInputProps<TFieldsValues>) {
    const { field, fieldState } = useController({ name, control, disabled });

    const handleBlur = () => {
        field.onBlur();
        onBlur?.();
    };

    return (
        <SelectInput
            label={label}
            options={options}
            filterOption={filterOption}
            value={field.value}
            className={className}
            nodeAfter={nodeAfter}
            helpText={helpText}
            getPopupContainer={getPopupContainer}
            dropdownMatchSelectWidth={dropdownMatchSelectWidth}
            showSearch={showSearch}
            onChange={field.onChange}
            onBlur={handleBlur}
            error={fieldState.error?.message}
            placeholder={placeholder}
            disabled={field.disabled}
            autoFocus={autoFocus}
            fieldRef={field.ref}
        />
    );
}
